var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.reload)?_c('TransactionTemplate',{ref:"sell-price-product",staticClass:"sell-price-product",attrs:{"screenJson":_vm.getScreenJson,"setLoading":_vm.setLoading,"localDataGrid":true,"backButtonRoute":undefined,"data-model":_vm.dataModel,"isLoaded":_vm.loaded,"validationSummary":_vm.validationSummary,"serverError":_vm.serverError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }